// @flow
import styled from 'styled-components';
import sidePanelTitleIconCss from 'esm-web-pro/components/layout/sidePanel/icons/sidePanelTitleIconCss';
import { ReactComponent as Icon } from 'esm-web-pro/assets/images/sidePanel/pipe.svg';

const PipeIcon = styled(Icon)`
    ${sidePanelTitleIconCss}
`;

export default PipeIcon;
